// frontend/src/components/ProfileBlockEditors/BarsBlockEditor.js
import React from 'react';
import { PlusIcon, DeleteIcon } from '../Icons';

const BarsBlockEditor = ({ block, onChange }) => {
    const handleTitleChange = (title) => {
        onChange({
            ...block,
            content: {
                ...block.content,
                title
            }
        });
    };

    const handleAddBar = () => {
        const items = block.content?.items || [];
        onChange({
            ...block,
            content: {
                ...block.content,
                title: block.content?.title || '',
                items: [...items, { label: '', value: 50 }]
            }
        });
    };

    const handleRemoveBar = (index) => {
        const items = block.content?.items || [];
        onChange({
            ...block,
            content: {
                ...block.content,
                items: items.filter((_, i) => i !== index)
            }
        });
    };

    const handleBarChange = (index, field, value) => {
        const items = [...(block.content?.items || [])];
        items[index] = {
            ...items[index],
            [field]: field === 'value' ? parseInt(value) || 0 : value
        };
        onChange({
            ...block,
            content: {
                ...block.content,
                items
            }
        });
    };

    return (
        <div className="flex flex-col gap-4">
            <div>
                <label className="block text-label-large text-surface-onVariant mb-1">
                    Titel
                </label>
                <input
                    type="text"
                    value={block.content?.title || ''}
                    onChange={(e) => handleTitleChange(e.target.value)}
                    placeholder="z.B. Meine Skills"
                    className="md3-textfield-outlined w-full"
                />
            </div>

            <div>
                <div className="flex justify-between items-center mb-2">
                    <span className="text-label-large font-bold text-surface-onVariant">Balken</span>
                    <button
                        onClick={handleAddBar}
                        className="md3-btn-text text-sm h-8"
                    >
                        <PlusIcon fontSize="small" className="mr-1" /> Hinzufügen
                    </button>
                </div>

                <div className="flex flex-col gap-2">
                    {(block.content?.items || []).map((item, index) => (
                        <div key={index} className="p-3 bg-surface-container rounded-lg border border-divider">
                            <div className="flex items-center gap-2 mb-2">
                                <div className="flex-1">
                                    <label className="block text-label-small text-surface-onVariant mb-1">Label</label>
                                    <input
                                        type="text"
                                        value={item.label}
                                        onChange={(e) => handleBarChange(index, 'label', e.target.value)}
                                        placeholder="z.B. Kreativität"
                                        className="md3-textfield-outlined w-full h-10 px-3 py-2 text-body-medium"
                                    />
                                </div>
                                <div className="w-1/4">
                                    <label className="block text-label-small text-surface-onVariant mb-1">Prozent</label>
                                    <input
                                        type="number"
                                        min="0"
                                        max="100"
                                        value={item.value}
                                        onChange={(e) => handleBarChange(index, 'value', e.target.value)}
                                        className="md3-textfield-outlined w-full h-10 px-3 py-2 text-body-medium text-right"
                                    />
                                </div>
                                <div className="pt-5">
                                    <button
                                        onClick={() => handleRemoveBar(index)}
                                        className="md3-icon-btn text-error hover:bg-error-container hover:text-error-on-container w-8 h-8"
                                        title="Entfernen"
                                    >
                                        <DeleteIcon fontSize="small" />
                                    </button>
                                </div>
                            </div>

                            {/* Slider Visual */}
                            <div className="flex items-center gap-3 px-1 mt-1">
                                <input
                                    type="range"
                                    min="0"
                                    max="100"
                                    value={item.value || 0}
                                    onChange={(e) => handleBarChange(index, 'value', e.target.value)}
                                    className="w-full accent-primary h-1 bg-surface-containerHighest rounded-lg appearance-none cursor-pointer"
                                />
                                <span className="text-label-small font-bold w-8 text-right">{item.value}%</span>
                            </div>
                        </div>
                    ))}

                    {(block.content?.items || []).length === 0 && (
                        <div className="text-center py-4 bg-surface-containerLow rounded-lg border border-dashed border-outlineVariant text-body-small text-surface-onVariant">
                            Keine Balken vorhanden. Füge welche hinzu.
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default BarsBlockEditor;
